import CardModifier from './CardModifier';
import GameObject from 'GameObject/GameObject';
import Point from 'Utility/Point';
import Sprite from 'Prototype/Sprite';
import Game from 'Game';

export default class RopeModifier extends CardModifier {
    onCreate(params: any): void {
        super.onCreate(params);

        this.addChild(
            GameObject.Instantiate(Sprite, {
                name: 'ropeSprite',
                texture: 'ropes_blocked_1',
                anchor: new Point(0.5, 0.5),
            })
        );
    }
    
    public static async preload(): Promise<void> {
        Game.resource.add('rope-card', 'resource/graphics/sprite_sheets/rope_card_animation.json');
    }
}
